<div class="table-container tw-w-[700px]">
  <table
    mat-table
    [dataSource]="dataSource"
    class="min-w-full border-separate border-spacing-0 matp-table-borderless"
  >
    <!-- 経由地点の表示/非表示ボタン行 -->
    <ng-container matColumnDef="displayButton">
      <td mat-cell *matCellDef="let element" class="tw-w-28 tw-max-w-28">
        @if (!expandedDetails && element.displayButton !== undefined) {
          <button
            mat-stroked-button
            class="tw-w-32 !tw-p-0"
            (click)="setDisplayViaLocation(true)"
          >
            <mat-icon>unfold_more</mat-icon>
            <span>経由 {{ viaPointLength }}地点</span>
          </button>
        } @else if (expandedDetails && element.displayButton !== undefined) {
          <button
            mat-stroked-button
            class="tw-w-32 !tw-p-0"
            (click)="setDisplayViaLocation(false)"
          >
            <mat-icon>unfold_less</mat-icon>
            <span>経由 {{ viaPointLength }}地点</span>
          </button>
        }
      </td>
    </ng-container>

    <!-- 時刻 -->
    <ng-container matColumnDef="timestamp">
      <td mat-cell *matCellDef="let element" class="tw-w-28 tw-max-w-28">
        @if (element.timestamp !== undefined) {
          <div [ngClass]="{ 'tw-min-h-5': element.type === 'arrivalPoint' }">
            {{ element.timestamp | date: "yyyy/MM/dd HH:mm" }}
          </div>
        }
      </td>
    </ng-container>

    <!-- ルート線 -->
    <ng-container matColumnDef="routeLine">
      <td
        mat-cell
        *matCellDef="let element"
        class="tw-min-w-10 tw-w-10 tw-max-w-10"
      >
        @if (element.type !== "startPoint") {
          <div
            class="route top"
            [ngClass]="{
              'not-arrived': !element.completed && !isCurrentLocation(element),
              'in-progress': element.type === 'inProgress',
            }"
          ></div>
        }
        @if (!element.displayButton && element.type !== "inProgress") {
          <div
            class="circle"
            [ngClass]="{
              'not-arrived':
                element.type === 'arrivalPoint' && !element.completed,
            }"
          >
            @if (element.type !== "arrivalPoint" || element.completed) {
              <mat-icon class="check-icon">check</mat-icon>
            }
          </div>
        }
        @if (element.type !== "arrivalPoint") {
          <div
            class="route"
            [ngClass]="{
              'not-arrived': !element.completed || isCurrentLocation(element),
            }"
          ></div>
        }
      </td>
    </ng-container>

    <!-- 状態 -->
    <ng-container matColumnDef="status">
      <td
        mat-cell
        *matCellDef="
          let element;
          let first = first;
          let last = last;
          let index = index
        "
        class="tw-w-24"
      >
        @if (element.type === "startPoint") {
          <div>
            {{
              element.completed && !element.currentLocation
                ? "出発"
                : "出発予定"
            }}
          </div>
        } @else {
          @if (element.timestamp !== undefined) {
            @if (
              element.type === "viaPoint" &&
              element.completed &&
              !element.currentLocation &&
              element.stayDurationText
            ) {
              <div>滞在 {{ element.stayDurationText }}</div>
            } @else {
              <div>{{ element.completed ? "到着" : "到着予定" }}</div>
            }
          }
        }
      </td>
    </ng-container>

    <!-- 地名 -->
    <ng-container matColumnDef="pointName">
      <td mat-cell *matCellDef="let element" class="tw-min-w-32 tw-w-32">
        {{ element.pointName }}
      </td>
    </ng-container>

    <!-- 現在地 -->
    <ng-container matColumnDef="currentLocation">
      <td
        mat-cell
        *matCellDef="let element"
        class="tw-max-w-16 tw-w-16 tw-min-w-16"
      >
        @if (isCurrentLocation(element)) {
          <ng-container>
            <mat-card
              class="tw-p-1 !tw-inline-block !matp-bg-accent !tw-text-white"
            >
              現在位置
            </mat-card>
          </ng-container>
        }
      </td>
    </ng-container>

    <!-- データ行の定義 -->
    <tr
      mat-row
      *matRowDef="let row; columns: displayedTableColumns"
      [ngClass]="createRowClass(row)"
    ></tr>
  </table>
</div>
